import {EventEmitter} from 'eventemitter3'

export const hospitalEvent = new EventEmitter()

export const hospitalEventTypes = {
    TABLE_CHANGE: 'TABLE_CHANGE',
    DETAIL_CHANGE: 'DETAIL_CHANGE',
}

export function getHospitalEventKey(eventType, clientId) {
    if (!eventType) {
        return ''
    }

    switch (eventType) {
        case hospitalEventTypes.TABLE_CHANGE:
            return `HOSPITAL_TABLE_CHANGE`

        case hospitalEventTypes.DETAIL_CHANGE:
            return `HOSPITAL_DETAIL_CHANGE`

        default:
            return ''
    }
}

export function onHospitalTableChangeListener(
    eventType = hospitalEventTypes.TABLE_CHANGE,
    data,
) {
    hospitalEvent.emit(getHospitalEventKey(eventType), data)
}

export function onHospitalDetailChangeListener(
    eventType = hospitalEventTypes.DETAIL_CHANGE,
    data,
) {
    hospitalEvent.emit(getHospitalEventKey(eventType), data)
}

export function onHospitalRolesChangeListener(
    eventType = hospitalEventTypes.ROLE_CHANGE,
    clientId,
    data,
) {
    hospitalEvent.emit(getHospitalEventKey(eventType, clientId), data)
}

export function onHospitalTableChangeRemoveListener(
    eventType = hospitalEventTypes.TABLE_CHANGE,
) {
    hospitalEvent.removeListener(getHospitalEventKey(eventType))
}

export function onHospitalDetailChangeRemoveListener(
    eventType = hospitalEventTypes.DETAIL_CHANGE,
) {
    hospitalEvent.removeListener(getHospitalEventKey(eventType))
}

export function onHospitalRoleChangeRemoveListener(
    eventType = hospitalEventTypes.ROLE_CHANGE,
    clientId,
) {
    hospitalEvent.removeListener(getHospitalEventKey(eventType, clientId))
}
